// @mui material components
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS Base Styles
import typography from "assets/theme/base/typography";
import { siteConfig } from "types/siteConfig";

function Footer({ light }: { light?: boolean }): JSX.Element {
  const { size } = typography;

  return (
    <MDBox width="100%" py={{ xs: 2, sm: 4 }}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "white" : "text"}
            fontSize={{ xs: "0.72rem", sm: size.sm }}
            textAlign="center"
            lineHeight={{ xs: 1.35, sm: 1.5 }}
            maxWidth={{ xs: 280, sm: "none" }}
          >
            &copy; {new Date().getFullYear()}, Desenvolvido por
            <Link href={siteConfig.siteDesenvolvedor} target="_blank">
              <MDTypography
                variant="button"
                fontWeight="medium"
                color={light ? "white" : "dark"}
                sx={{ fontSize: { xs: "0.72rem", sm: size.sm } }}
              >
                &nbsp;{siteConfig.desenvolvedor}&nbsp;
              </MDTypography>
            </Link>
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Declaring default props for Footer
Footer.defaultProps = {
  light: false,
};

export default Footer;
